import VueRouter from 'vue-router';
import {scrollBehavior} from './helpers/tools';
import HomePage from "./pages/HomePage";



const routes = [
  {
    path: '',
    name: 'HomePage',
    component: HomePage
  },
];

const RouterComponent = {
  /**
   *
   * @param h
   * @returns {*}
   */
  render(h) {
    return <router-view />;
  }
};

export default RouterComponent;

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior,
  routes
});

export {router};
